import { useParams } from 'react-router-dom';

import { AppFormatsSettingsPage } from '~/components/pages/AppFormatsSettingsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppFormatsSettingsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppFormatsSettingsPage appId={appId} />
    </DashboardTemplate>
  );
};
